<div class="bg-white rounded-lg shadow-lg p-4 flex flex-col gap-1 relative w-full h-full">
    @if (title) {
      <vw-card-block-title [label]="title" />
    }
    <ng-content></ng-content>
</div>